import commonRoutingService from 'common/services/commonRoutingService';
import urlUtil from 'common/util/url/urlUtil';
import { MarkingFlow } from 'common/features/footer/types';

const urlContextParametersService = {
    setPartyId(partyId: number, silent?: boolean): void {
        commonRoutingService.setNewUrlSearchString({ partyId }, silent);
    },
    setQuestionId(questionId: number): void {
        commonRoutingService.setNewUrlSearchString({ questionId });
    },
    setWorkspaceId(workspaceId: string): void {
        commonRoutingService.setNewUrlSearchString({ workspaceId });
    },
    setSelectedCommitteeId(committeeId: number, selectedPartyId: number, silent?: boolean): void {
        // reset partyId when switching committee
        commonRoutingService.setNewUrlSearchString({ selectedCommitteeId: committeeId, partyId: selectedPartyId }, silent);
    },
    setWorkspaceIdAndPartyId(workspaceId: string, partyId: number): void {
        commonRoutingService.setNewUrlSearchString({ workspaceId, partyId });
    },
    setMarkingFlow(flow: MarkingFlow, silent?: boolean): void {
        commonRoutingService.setNewUrlSearchString({ markingFlow: flow }, silent);
    },
    getMarkingFlow(): MarkingFlow | null {
        const params = urlUtil.parseLocationSearchString(window.location.search);
        const value = String(params.markingFlow || '').toLowerCase();
        return value === 'candidate' || value === 'question' ? (value as MarkingFlow) : null;
    },
};

export default urlContextParametersService;
